// Singleton Action Cable consumer.
//
// One connection per browser tab, shared by any hook or component that
// wants to subscribe to a channel. Rails mounts the cable at /cable by
// default; the consumer picks that up automatically.
//
// Session identity travels over the existing Devise cookie: no extra
// auth wiring needed on the client. ApplicationCable::Connection
// resolves current_user server-side via env['warden'].
import { createConsumer, Consumer } from '@rails/actioncable';

let consumer: Consumer | null = null;

export function getCable(): Consumer {
  if (!consumer) {
    consumer = createConsumer();
  }
  return consumer;
}
